import * as React from 'react'
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import MarginRow from "./MarginRow";
import {
  Button,
  Hidden,
  isWidthDown,
  LinearProgress,
  MenuItem,
  Typography,
  withWidth,
  WithWidth
} from "@material-ui/core";
import {inject, observer} from "mobx-react";
import logo from '../../images/logo.png'
import ControlTower, {Routes} from "../../components/ControlTower";
import SimpleMenu from "./SimpleMenu";
import config from "react-global-configuration";
import UserStore from "../../stores/UserStore";
import Progress from "../Progress";
import Tracking from "../Tracking";
import PopperMenuItem from "./PopperMenuItem";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import {observable} from "mobx";
import {HelpMenu} from "./HelpMenu";

const styles = (theme: Theme) => createStyles({
  appBar: {
    top: 0,
    backgroundColor: theme.palette.primary.dark,
    height: 56,
    maxHeight: 56,
  },
  toolBar: {
    minHeight: 56,
    height: 56
  },
  linkStyle: {
    marginBottom: '-5px',
    marginLeft: 5
  },
  appLogo: {
    height: 45,
    width: 45
  },
  button: {
    margin: theme.spacing(1),
    color: theme.palette.common.white,
    fontWeight: 300,
    padding: 0,
  },
  activeButton: {
    margin: theme.spacing(1),
    fontWeight: 600,
    color: theme.palette.common.white,
    borderBottom: "3px solid",
    borderBottomColor: theme.palette.secondary.main,
    borderRadius: 0,
    padding: 0
  },
  input: {
    display: 'none',
  },
  title: {
    color: theme.palette.primary.contrastText,
    flexGrow: 1,
    paddingLeft: theme.spacing(1)
  },
  icon: {
    height: 20,
    width: 20,
  },
  progressWrapper: {
    flexGrow: 1
  },
  progress: {
    height: 3,
    backgroundColor: theme.palette.secondary.main
  },
})

interface IHeaderProps {
  userStore?: UserStore
  progress?: Progress
}

@inject("userStore", "progress")
@observer
class Header extends React.Component<WithStyles<typeof styles>& WithWidth & IHeaderProps> {
  @observable anchorEl: Element | null = null

  handleClick = (event: any) => {
    this.anchorEl = event.currentTarget
  }

  handleClose = () => {
    this.anchorEl = null
  }

  render() {
    const {classes, userStore,  progress} = this.props

    return (
      <AppBar position="fixed" className={classes.appBar}>
        <MarginRow>
          <Toolbar className={classes.toolBar} disableGutters={ true }>
            <a href={config.get('homeUrl')} className={classes.linkStyle}>
              <img src={logo} className={classes.appLogo} alt="logo" />
            </a>
            <Typography variant="h6" color="inherit" className={classes.title}>
              Hazmat & Rescue
            </Typography>
            <Hidden xsDown>
              {this.renderMenuItems()}
            </Hidden>
            <Hidden smUp>
              {userStore!.user &&
                <SimpleMenu />
              }
              {!userStore!.user &&
                <React.Fragment></React.Fragment>
              }
            </Hidden>
          </Toolbar>
        </MarginRow>
        <div className={classes.progressWrapper}>
          { <LinearProgress hidden={ !progress!.isVisible } className={ classes.progress } /> }
        </div>
      </AppBar>

    )
  }

  renderMenuItems = () => {
    const {
      classes,
      userStore,
    } = this.props

    if (!userStore || !userStore.isAuthenticated) {
      return null
    }

    const currentPath = ControlTower.currentRoute

    const menuItems = []
    // menuItems.push(
    //   <Button
    //     key="0"
    //     color="primary"
    //     aria-label="Home"
    //     className={classes.button}
    //     onClick={this.onClickHome}
    //   >
    //     Home
    //   </Button>
    // )

    if (userStore.isAdmin) {
      menuItems.push(
        <Button
          key="accounts"
          color="primary"
          aria-label="Accounts"
          className={currentPath === Routes.accounts ? classes.activeButton : classes.button}
          onClick={this.onClickAccounts}
        >
          Accounts
        </Button>
      )

      menuItems.push(
        <Button
          key="people"
          color="primary"
          aria-label="People"
          className={currentPath === Routes.people ? classes.activeButton : classes.button}
          onClick={this.onClickPeople}
        >
          People
        </Button>
      )

      menuItems.push(
        <Button
          key="reports"
          color="primary"
          aria-label="Reports"
          className={currentPath === Routes.reports ? classes.activeButton : classes.button}
          onClick={this.onClickReports}
        >
          Reports
        </Button>
      )
      menuItems.push(
        <Button
          key="courses"
          color="primary"
          aria-label="Courses"
          className={currentPath.startsWith(Routes.courses) ? classes.activeButton : classes.button}
          onClick={this.onClickCourses}
        >
          Courses
        </Button>
      )
    } else {
      menuItems.push(
        <Button
          key="my-classes"
          color="primary"
          aria-label="My Classes"
          className={currentPath === Routes.myClasses ? classes.activeButton : classes.button}
          onClick={this.onClickMyClasses}
        >
          My Classes
        </Button>
      )
      menuItems.push(
        <Button
          key="account"
          color="primary"
          aria-label="Account"
          className={currentPath.startsWith(Routes.account) ? classes.activeButton : classes.button}
          onClick={this.onClickAccount}
        >
          Account
        </Button>
      )
      if (userStore!.isOwner) {
        menuItems.push(
          <Button
            key="reports"
            color="primary"
            aria-label="Reports"
            className={currentPath === Routes.reports ? classes.activeButton : classes.button}
            onClick={this.onClickReports}
          >
            Reports
          </Button>
        )
      }
    }

    if (userStore!.isAdmin) {
      const helpMenu = HelpMenu
      const helpMenuList = helpMenu.map((item: any) => {
        return {label: item.label, onClick: () => this.onClickHelp(item.href)}
      })

      menuItems.push(
        <PopperMenuItem
          key='help'
          button={(props) => this.getHelpMenuItemButton('Help', "", "", props, true)}
          menuList={helpMenuList}
          // menuList={[
          //   { label: 'Merge accounts', onClick: () => this.onClickHelp("https://app.tango.us/app/workflow/Merge-users-and-classes-from-one-account-to-another-60049db842a2488ba751eefc615f62cc"), tracking: "Merge-users-and-classes-from-one-account-to-another" },
          //   { label: 'Move user to another account', onClick: () => this.onClickHelp("https://app.tango.us/app/workflow/Move-a-user-to-another-account-db46733035e242a4af7633230e5b432a"), tracking: "Move-a-user-to-another-account" },
          // ]}
          onClick={async (e) => {
            this.handleClose()
          }}
        />
      )
    }

    menuItems.push(
      <Button
        key="sign-out"
        color="primary"
        className={classes.button}
        aria-label="Sign Out"
        onClick={this.onClickSignOut }
      >
        Sign Out
      </Button>
    )

    return menuItems
  }

  onClickHelp = (url: string) => {
    window.open(url, "_blank")
  }

  getHelpMenuItemButton = (label: string | React.ReactNode, tracking: string, route: string, otherProps: any = {}, renderArrow: boolean = false) => {
    const { classes, width } = this.props

    const Comp: any = isWidthDown('sm', width) ? MenuItem : Button
    const isActive = false

    return (
      <Comp
        key={tracking}
        button
        color="primary"
        aria-label={label}
        className={isActive ? classes.activeButton : classes.button}
        {...otherProps}
        onClick={async (e: React.MouseEvent) => {
          Tracking.event({ category: 'Navigation', action: tracking })
          if (otherProps.onClick) {
            await otherProps.onClick(e)
          }
          if (route) {
            ControlTower.open(route, "Hazmat & Rescue - Help")
          }
        }}>
        {label} {renderArrow && <ArrowDropDownIcon />}
      </Comp>
    )
  }

  get accountId(): string | undefined {
    const { userStore } = this.props
    if (userStore!.user && userStore!.user.account) {
      return userStore!.user!.account.id
    } else {
      return undefined
    }
  }

  onClickAccount = (event: any) => {
    ControlTower.route(`${Routes.account}/${this.accountId}`)
  }

  onClickAccounts = (event: any) => {
    ControlTower.route(Routes.accounts)
  }

  onClickPeople = (event: any) => {
    ControlTower.route(Routes.people)
  }

  onClickReports = (event: any) => {
    ControlTower.route(Routes.reports)
  }

  onClickHome = (event: any) => {
    ControlTower.route(Routes.home)
  }

  onClickMyClasses = (event: any) => {
    ControlTower.route(Routes.myClasses)
  }

  onClickCourses = (event: any) => {
    ControlTower.route(Routes.courses)
  }

  onClickSignOut = async (event: any) => {
    Tracking.event({action: "SignOut"})
    ControlTower.route(Routes.signout)
    // ControlTower.route(Routes.signin, { state: { signout: true}})
    // await this.props.userStore!.signOut()
  }
}

export default withStyles(styles)(withWidth()(Header))